import React, { useMemo, useState } from "react";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Box, Button } from "@mui/material";
import { useLocation } from "react-router-dom";
import TutorialCadastro from "./TutorialCadastro";
import { obterTutorialEnsaio } from "./catalogoTutoriaisEnsaios";

export default function BotaoTutorialPagina({ label = "Ver tutorial", sx }) {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const tutorial = useMemo(
    () => obterTutorialEnsaio(location.pathname),
    [location.pathname]
  );

  if (!tutorial) return null;

  return (
    <>
      <Box
        aria-hidden="true"
        sx={{ height: { xs: 72, md: 84 }, flexShrink: 0, "@media print": { display: "none" } }}
      />
      <Button
        className="botao-tutorial-pagina"
        type="button"
        variant="outlined"
        startIcon={<HelpOutlineIcon />}
        onClick={() => setOpen(true)}
        sx={{ whiteSpace: "nowrap", ...sx }}
      >
        {label}
      </Button>
      <TutorialCadastro
        open={open}
        onClose={() => setOpen(false)}
        titulo={`Tutoriais — ${tutorial.titulo}`}
        subtitulo={tutorial.normas}
        etapas={tutorial.sistema}
        etapasExecucao={tutorial.execucao}
      />
    </>
  );
}
